<template>
  <div>
    <multiselect
      :id="id"
      :name="name"
      class="c-form-multiselect"
      :options="selectOptions"
      :multiple="false"
      :label="displayField"
      track-by="id"
      v-model="inputValue"
      :taggable="false"
      placeholder
      @search-change="asyncFind"
      :show-valid-tick="showValidTick"
      :group-values="groupValues"
      :group-label="groupLabel"
      :group-select="groupSelect"
      :disabled="disabled"
    >
      <template slot="singleLabel" slot-scope="props">
        <!-- <img class="c-user-select__image" :src="props.option.img" :alt="props.option.name"> -->
        <span class="c-user-select__item">
          <span class="c-user-select__name">{{
            props.option[displayField]
          }}</span>
        </span>
      </template>

      <template slot="noResult"
        >No results found. Please try searching again.</template
      >

      <template slot="option" slot-scope="props">
        <!-- <img class="c-user-select__image" :src="props.option.img" :alt="props.option.name"> -->
        <span class="c-user-select__item">
          <span class="c-user-select__name">{{
            props.option[displayField]
          }}</span>
        </span>
      </template>

      <template slot="tag" slot-scope="{ option, remove }">
        <span class="c-form-multiselect__tag">
          <span>{{ option.name || option.email }}</span>
          <span class="c-form-multiselect__remove" @click="remove(option)">
            <icon name="cross" width="10" height="10"></icon>
          </span>
        </span>
      </template>
    </multiselect>
    <span class="c-form__validation-message" v-if="error">{{ error }}</span>
  </div>
</template>

<script>
//TODO: Make this a bit more global
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'
export default {
  name: 'ParentPageSelector',
  methods: {
    asyncFind: debounce(function(query) {
      // TODO: Should only fire if there are no results visible
      this.isLoading = true
      this.$store.dispatch(this.asyncAction, query).then((response) => {
        const results = response
        // if there is a result already, put this in the top of the list
        if (this.inputValue && this.inputValue.id) {
          const set = new Set([this.inputValue, ...results])
          this.selectOptions = [...set]
        } else {
          this.selectOptions = results
        }
        this.isLoading = false
      })
    }, 500),
  },
  props: {
    id: [Number, String],
    asyncAction: {
      type: String,
      default: '',
    },
    displayField: {
      type: String,
      default: 'title',
    },
    name: String,
    value: [String, Object, Array, Number],
    error: String,
    permissions: Array,
    multiple: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    showValidTick: Boolean,
    placeholder: String,
    groupValues: String,
    groupLabel: String,
    groupSelect: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: function() {
    return {
      selectOptions: this.options,
      inputValue: null,
    }
  },
  mounted() {
    this.inputValue = this.value
  },
  watch: {
    inputValue(newVal, oldVal) {
      // if we are de-selecting
      if (oldVal && !newVal) {
        this.$emit('input', null)
        return
      }
      if (newVal && oldVal && oldVal.id !== newVal.id) {
        if (newVal) {
          this.$emit('input', newVal)
          return
        } else {
          this.$emit('input', null)
          return
        }
      }

      if (newVal && !oldVal) {
        this.$emit('input', newVal)
        return
      }
    },
    // not sure why the following arent happening as part of data()

    options: {
      immediate: true,
      deep: false,
      handler(newValue, oldValue) {
        if (this.inputValue && this.inputValue.id) {
          // if we have a pre-selected value, we need to move to the top of the list
          // strip any duplicates
          const set = new Set([this.inputValue, ...this.options])
          this.selectOptions = [...set]
          return
        }
        this.selectOptions = newValue
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
